import React from 'react';
import PropTypes from 'prop-types';
import { TvAnchor, TvDiv, TvP, TvSmall, TvSpan } from '@trustvid/design-system';
import { getLoginFeaturedMarketingDemoPacks } from '../../../constants/marketingDemosCatalog';
import { isMarketingDemosPublicEnabled } from '../../../utils/marketing-demos-visibility';

/**
 * High-level marketing CTAs for demo stories on the login panel (staging / non-prod).
 * Matches the glass “Built for Scale” panel: light headers on purple, white story cards.
 */
const LoginMarketingUseCases = ({ compact = false }) => {
  if (!isMarketingDemosPublicEnabled()) {
    return null;
  }

  const packs = getLoginFeaturedMarketingDemoPacks();
  if (packs.length === 0) {
    return null;
  }

  return (
    <TvDiv
      className={`tv-login-page__use-cases${compact ? ' tv-login-page__use-cases--compact' : ''}`}
      data-testid="login-marketing-use-cases"
    >
      <TvDiv
        className={`tv-login-page__use-cases-panel rounded-4${
          compact ? ' tv-login-page__use-cases-panel--compact' : ''
        }`}
      >
        <TvDiv className="tv-login-page__use-cases-header">
          <TvSmall className="tv-login-page__use-cases-eyebrow mb-0">See it in action</TvSmall>
          <TvP className="tv-login-page__use-cases-title mb-0">Demo use cases</TvP>
          <TvP className="tv-login-page__use-cases-lead mb-0">
            Open a ready story — no sign-in required.
          </TvP>
        </TvDiv>

        <TvDiv
          className={`tv-login-page__use-cases-grid${
            compact ? ' tv-login-page__use-cases-grid--compact' : ''
          }`}
          data-testid="login-marketing-use-cases-list"
        >
          {packs.map((pack, index) => (
            <TvAnchor
              key={pack.id}
              href={pack.href}
              target="_blank"
              rel="noreferrer"
              className={`tv-login-page__use-cases-card${
                index === 0 ? ' tv-login-page__use-cases-card--primary' : ''
              }`}
              data-testid={`login-marketing-use-case-open-${pack.id}`}
            >
              <TvDiv
                className="tv-login-page__use-cases-card-icon"
                aria-hidden="true"
                data-testid={`login-marketing-use-case-${pack.id}`}
              >
                <i className={`mdi ${pack.icon}`} />
              </TvDiv>
              <TvDiv className="tv-login-page__use-cases-card-body">
                {pack.badge ? (
                  <TvSpan
                    className="tv-login-page__use-cases-card-badge"
                    data-testid={`login-marketing-use-case-badge-${pack.id}`}
                  >
                    {pack.badge}
                  </TvSpan>
                ) : null}
                <TvSpan className="tv-login-page__use-cases-card-title">{pack.shortTitle}</TvSpan>
                <TvSmall className="tv-login-page__use-cases-card-desc mb-0">
                  {pack.shortDescription}
                </TvSmall>
                <TvSpan className="tv-login-page__use-cases-card-cta">
                  View story
                  <i className="mdi mdi-arrow-right" aria-hidden="true" />
                </TvSpan>
              </TvDiv>
            </TvAnchor>
          ))}
        </TvDiv>
      </TvDiv>
    </TvDiv>
  );
};

LoginMarketingUseCases.propTypes = {
  compact: PropTypes.bool,
};

export default LoginMarketingUseCases;
